const env: any = process.env.REACT_APP_ENV
  ? process.env.REACT_APP_ENV
  : "local";
export const serverData: any = {
  local: "http://localhost:8086",
  qa: "http://localhost:8086",
  staging: "s",
  production: "",
};

export const securityServer: any = {
  local: "http://localhost:8086",
  qa: "https://api-qa.planetwise.io",
  staging: "s",
  production: "https://api.planetwise.io",
};

export const userServer: any = {
  local: "http://localhost:8087",
  qa: "https://api-qa.planetwise.io",
  staging: "s",
  production: "https://api.planetwise.io",
};

export const greenMirror: any = {
  local: "http://localhost:3000",
  qa: "https://qa.greenmirror.ai",
  production: "https://greenmirror.ai",
};
export const greenMirrorBackend: any = {
  local: "http://localhost:4000",
  qa: "https://qa.greenmirror.ai/api",
  production: "https://greenmirror.ai/api",
};
export const greenMirrorUrl = greenMirror[env];
export const orgServer: any = {
  local: "http://localhost:8088",
  qa: "https://api-qa.planetwise.io",
  staging: "",
  production: "https://api.planetwise.io",
};
export const emissionServer: any = {
  local: "http://localhost:8084",
  qa: "https://api-qa.planetwise.io",
  staging: "s",
  production: "https://api.planetwise.io",
};
export const bulkUploadServer: any = {
  local: "https://gateway-qa.planetwise.io/fileupload",
  qa: "https://gateway-qa.planetwise.io/fileupload",
  staging: "https://gateway-qa.planetwise.io/fileupload",
  production: "https://gateway.planetwise.io/fileupload",
};
export const assetServer: any = {
  local: "http://localhost:8083",
  qa: "https://api-qa.planetwise.io",
  staging: "s",
  production: "https://api.planetwise.io",
};
export const rbacServer: any = {
  local: "http://localhost:8090",
  qa: "https://api-qa.planetwise.io",
  staging: "s",
  production: "https://api.planetwise.io",
};

export const srmServer: any = {
  local: "http://localhost:8095",
  qa: "https://api-qa.planetwise.io",
  staging: "s",
  production: "https://api.planetwise.io",
};

export const subscriptionServer: any = {
  local: "http://localhost:8091",
  qa: "https://api-qa.planetwise.io",
  staging: "s",
  production: "https://api.planetwise.io",
};

export const auditServer: any = {
  local: "http://localhost:8092",
  qa: "https://api-qa.planetwise.io",
  staging: "s",
  production: "https://api.planetwise.io",
};

export const NotificationServer: any = {
  local: "http://localhost:8093",
  qa: "https://api-qa.planetwise.io",
  staging: "s",
  production: "https://api.planetwise.io",
};

export const verificationServer: any = {
  local: "http://localhost:8094",
  qa: "https://api-qa.planetwise.io",
  staging: "s",
  production: "https://api.planetwise.io",
};
const reportAssetUrl: any = {
  qa: "https://pw-cms-qa.s3.ap-southeast-1.amazonaws.com/",
  production: "https://pw-cms-prod.s3.ap-southeast-1.amazonaws.com/",
};

export const reportAssetsPath = reportAssetUrl[env];

export const API_PATH = () => ({
  apis: {
    industries: orgServer[env] + "/accessmanager/organisation/v1/industries",
    businessUnitTypes: orgServer[env] + "/organisation/v1/businessunit-types",
    signIn: userServer[env] + "/accessmanager/user/v1/signin",
    signUp: orgServer[env] + "/accessmanager/organisation/v1/signup",
    verifyUserRegister: userServer[env] + "/accessmanager/user/v1/verify",
    verify2FAAuthOTP:
      userServer[env] + "/accessmanager/user/v1/verify-2fa-auth-otp",
    forgotPassword: userServer[env] + "/accessmanager/user/v1/forgot-password",
    userProfile: userServer[env] + "/user/v1/userprofile",
    resetPassword: userServer[env] + "/user/v1/reset-password",
    resendOTP: userServer[env] + "/accessmanager/user/v1/resend-otp",
    emailAuthOtp: userServer[env] + "/accessmanager/user/v1/email-auth-otp",
    businessUsers: userServer[env] + "/user/v1/userprofiles",
    userOnboardingStatus:
      userServer[env] + "/accessmanager/user/v1/user-onboarding-status",
    urlVerification:
      userServer[env] + "/accessmanager/user/v1/url-verification",
    addemployee: userServer[env] + "/user/v1/employee",
    fetchemployee: userServer[env] + "/user/v1/employees",
    updateEmployeeStatus: userServer[env] + "/user/v1/employeestatus",
    deleteEmployee: userServer[env] + "/user/v1/remove-employee",
    removeAdminAssociations:
      userServer[env] + "/user/v1/remove-admin-associations",
    employeelink: userServer[env] + "/user/v1/employee-link",
    userDetails: userServer[env] + "/user/v1/user-details",
    generateAppAuthQR:
      userServer[env] + "/accessmanager/user/v1/generate-app-auth-qr",
    verifyAndSetAppAuth:
      userServer[env] + "/accessmanager/user/v1/verify-and-set-app-auth",
    deleteUserAssociations:
      userServer[env] + "/user/v1/delete-user-associations",
    employeesCount: userServer[env] + "/user/v1/employees-count",

    //security
    session: securityServer[env] + "/security/v1/session",
    sessions: securityServer[env] + "/security/v1/sessions",

    //organisation
    businessUnit: orgServer[env] + "/organisation/v1/businessunit",
    businessUnits: orgServer[env] + "/organisation/v1/businessunits",
    businessunitsCount: orgServer[env] + "/organisation/v1/businessunits-count",
    businessUnitActions:
      orgServer[env] + "/organisation/v1/businessunit-actions",
    deleteBusinessUnit: orgServer[env] + "/organisation/v1/remove-businessunit",
    companyBusinessUnits:
      orgServer[env] + "/organisation/v1/company-businessunits",
    businessUnitPreference:
      orgServer[env] + "/organisation/v1/businessunitpreference",

    defaultpreferences: orgServer[env] + "/organisation/v1/default-preferences",
    department: orgServer[env] + "/organisation/v1/department",
    departments: orgServer[env] + "/organisation/v1/departments",
    settingsInfo: orgServer[env] + "/organisation/v1/settings-info",
    company: orgServer[env] + "/organisation/v1/company",
    companypreferences: orgServer[env] + "/organisation/v1/companypreferences",
    trainingVideos: orgServer[env] + "/organisation/v1/training-videos",

    //emission apis
    protocolcategories: emissionServer[env] + "/emission/v1/protocolcategories",
    availablecategories:
      emissionServer[env] + "/emission/v1/availablecategories",
    scopecategories: emissionServer[env] + "/emission/v1/scopecategories",
    countries: emissionServer[env] + "/emission/v1/countries",
    currencies: emissionServer[env] + "/emission/v1/alluoms",
    moduletypes: emissionServer[env] + "/emission/v1/moduletypes",
    moduletypesbygroups:
      emissionServer[env] + "/emission/v1/moduletypesbygroups",
    methods: emissionServer[env] + "/emission/v1/methods",
    methodsbyfactors: emissionServer[env] + "/emission/v1/methodsbyfactors",

    factors: emissionServer[env] + "/emission/v1/factors",

    pcmMappings: emissionServer[env] + "/emission/v1/pcm-mappings",

    emissionsource: emissionServer[env] + "/emission/v1/emissionsource",

    emission: emissionServer[env] + "/emission/v1/emission",
    emissionlog: emissionServer[env] + "/emission/v1/emissionlog",
    emissions: emissionServer[env] + "/emission/v1/emissions",
    totalemissions: emissionServer[env] + "/emission/v1/totalemissions",
    emissionsbyscopeandmonth:
      emissionServer[env] + "/emission/v1/emissionsbyscopeandmonth",
    emissionsbyscopeandcategories:
      emissionServer[env] + "/emission/v1/emissionsbyscopeandcategories",
    allemissions: emissionServer[env] + "/emission/v1/allemissions",
    emissionsmonth: emissionServer[env] + "/emission/v1/allemissionsbymonth",
    emissionsbyunit: emissionServer[env] + "/emission/v1/emissionsbyunit",
    emissionsbyyear: emissionServer[env] + "/emission/v1/emissionsbyyear",
    importfiles: emissionServer[env] + "/emission/v1/importfiles",
    uoms: emissionServer[env] + "/emission/v1/uoms",
    uom: emissionServer[env] + "/emission/v1/uom",
    samplefile: emissionServer[env] + "/emission/v1/samplefile",
    importfile: emissionServer[env] + "/emission/v1/importfile",
    processfile: emissionServer[env] + "/emission/v1/emission-logs",
    discardemissions: emissionServer[env] + "/emission/v1/emissions",
    report: emissionServer[env] + "/emission/v1/report",
    summaryreport: emissionServer[env] + "/emission/v1/summary-report",
    bulkupload: bulkUploadServer[env],
    emissiontypes: emissionServer[env] + "/emission/v1/emissiontypes",
    removefile: emissionServer[env] + "/emission/v1/importfile",
    targetuoms: emissionServer[env] + "/emission/v1/targetuoms",
    attachments: emissionServer[env] + "/emission/v1/attachment",
    carbonprice: emissionServer[env] + "/emission/v1/carbonprice",
    targets: orgServer[env] + "/organisation/v1/targets",
    discardtargets: orgServer[env] + "/organisation/v1/targets",
    target: orgServer[env] + "/organisation/v1/target",
    targetsbyyear: orgServer[env] + "/organisation/v1/targets-year",
    metricsbyyear: orgServer[env] + "/organisation/v1/metrics-year",
    custommetrics: orgServer[env] + "/organisation/v1/custom-metrics",
    emissionsData: emissionServer[env] + "/emission/v1/target-actual-emissions",
    emissionstatus: emissionServer[env] + "/emission/v1/emissionstatus",
    recentemissions: emissionServer[env] + "/emission/v1/recent-emissions",
    allcategories: emissionServer[env] + "/emission/v1/categories",
    emissionfactor: emissionServer[env] + "/emission/v1/emissionfactor",
    customemissionfactors:
      emissionServer[env] + "/emission/v1/custom-emissionfactors",
    customemissionfactor:
      emissionServer[env] + "/emission/v1/custom-emissionfactor",

    //asset
    emissionsources: emissionServer[env] + "/emission/v1/emissionsources",
    emissionfactorshierarchy:
      emissionServer[env] + "/emission/v1/emissionfactors-hierarchy",
    asset: assetServer[env] + "/asset/v1/asset",
    assets: assetServer[env] + "/asset/v1/assets",
    assetactions: assetServer[env] + "/asset/v1/asset-actions",
    permissions: rbacServer[env] + "/rbac/v1/permissions",

    //srm
    supplier: srmServer[env] + "/srm/v1/supplier",
    suppliers: srmServer[env] + "/srm/v1/suppliers",
    supplierCount: srmServer[env] + "/srm/v1/supplier-count",
    registerSupplier: srmServer[env] + "/srm/v1/supplier-link",
    validateSupplier:
      srmServer[env] + "/accessmanager/srm/v1/validate-supplier",
    customers: srmServer[env] + "/srm/v1/customers",
    customerCount: srmServer[env] + "/srm/v1/customer-count",
    supplierEmissions: srmServer[env] + "/srm/v1/emission-data",
    supplierYtdData: srmServer[env] + "/srm/v1/ytd-data",
    supplierTimePeriods: srmServer[env] + "/srm/v1/time-periods",
    supplierStatusAggregate:
      srmServer[env] + "/srm/v1/supplier-status-aggregate",
    supplierEmissionAggregate:
      srmServer[env] + "/srm/v1/supplier-emission-aggregate",
    getSupplierESGData: srmServer[env] + "/srm/v1/esg-aggregate",
    supplierField: srmServer[env] + "/srm/v1/supplier-field",
    orgSupplierFields: srmServer[env] + "/srm/v1/supplier-fields",
    suppliersWithTotalEmissionRecords:
      srmServer[env] + "/srm/v1/suppliers-total-emission-records",
    supplierAllocations: srmServer[env] + "/srm/v1/supplier-allocations",
    supplierReport: srmServer[env] + "/srm/v1/supplier-report",

    //subscription
    plans: subscriptionServer[env] + "/accessmanager/subscription/v1/plans",
    zohoCustomer:
      subscriptionServer[env] + "/accessmanager/subscription/v1/zoho-customer",
    zohoSubscription:
      subscriptionServer[env] +
      "/accessmanager/subscription/v1/zoho-subscription",
    subscription: subscriptionServer[env] + "/subscription/v1/subscription",
    subscriptionTransactions:
      subscriptionServer[env] + "/subscription/v1/transactions",
    upgradeSubscription:
      subscriptionServer[env] + "/subscription/v1/upgrade-subscription",
    //subscription payment
    paymentrequest:
      subscriptionServer[env] + "/subscription/v1/payment-request",
    cardStatus: subscriptionServer[env] + "/subscription/v1/card-status",

    //subscription addons
    addons: subscriptionServer[env] + "/subscription/v1/addons",
    increaseAddon: subscriptionServer[env] + "/subscription/v1/increase-addon",
    //audit
    activityaudit: auditServer[env] + "/audit/v1/activity-audit",

    //offset
    offset: orgServer[env] + "/organisation/v1/offset",
    offsetstatus: orgServer[env] + "/organisation/v1/offset-status",
    offsets: orgServer[env] + "/organisation/v1/offsets",
    offsetsByYear: orgServer[env] + "/organisation/v1/offsets-year",
    offsetsByMonth: orgServer[env] + "/organisation/v1/offsets-month",
    offsetprogram: orgServer[env] + "/organisation/v1/offset-program",
    offsetprograms: orgServer[env] + "/organisation/v1/offset-programs",

    //announcements
    userannoucements:
      NotificationServer[env] + "/notification/v1/user-annoucements",
    announcementtransaction:
      NotificationServer[env] + "/notification/v1/announcement-transaction",

    //audit
    auditrequest: verificationServer[env] + "/verify/v1/audit-request",
    auditrequests: verificationServer[env] + "/verify/v1/audit-requests",
    auditRequestsDetails:
      verificationServer[env] + "/verify/v1/audit-request-details",
    externalVerifierOtp:
      verificationServer[env] + "/accessmanager/verify/v1/audit-otp",
    externalVerifierResendOtp:
      verificationServer[env] + "/accessmanager/verify/v1/resend-otp",
    externalVerifierOtpVerify:
      verificationServer[env] + "/accessmanager/verify/v1/verify-otp",

    //external Verifier status
    externalVerifierStatus:
      emissionServer[env] + "/emission/v1/verify-emissions",
    externalVerifierEmissionSummary:
      emissionServer[env] + "/emission/v1/verifier-emissions-summary",
    checkGMUser: userServer[env] + "/accessmanager/user/v1/check-email-gm",
    getCompanyOrFacility:
      orgServer[env] + "/accessmanager/organisation/v1/company-or-businessunit",
    checkUserAssociation:
      userServer[env] + "/accessmanager/user/v1/check-user-association",
    supplierPreferences: srmServer[env] + "/srm/v1/supplier-preferences",
    checkDuplicateSupplier: srmServer[env] + "/srm/v1/check-duplicate-supplier",
    supplierBulkUpload: srmServer[env] + "/srm/v1/bulk-upload",
    supplierAllocationPreference:
      srmServer[env] + "/srm/v1/supplier-allocation-preference",
    activateSupplier: srmServer[env] + "/srm/v1/activate-supplier",
    categoryMapping: greenMirrorBackend[env] + "/map-category",
    supplierAllocatedEmissions:
      srmServer[env] + "/srm/v1/supplier-allocations-total",
    disclosure: orgServer[env] + "/organisation/v1/disclosure",
    downloadGRIIndex: emissionServer[env] + "/emission/v1/gri-index-report",
    griYearwiseData: emissionServer[env] + "/emission/v1/gri-year-wise",
    niccodes: orgServer[env] + "/organisation/v1/niccodes",
    brsrData: emissionServer[env] + "/emission/v1/brsr-data",
  },
});

export const UIServerPaths: any = {
  local: "http://localhost:3000",
  qa: "https://qa.planetwise.io",
  staging: "https://app.planetwise.io",
  production: "https://app.planetwise.io",
};

export const UI_SERVER_PATH = () => UIServerPaths[env];
